export default __webpack_public_path__ + "static/media/CO.0bd146a8.svg";